"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomAvatar = CustomAvatar;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function CustomAvatar(_ref) {
  var name = _ref.name,
    logo = _ref.logo,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 3 : _ref$size,
    color = _ref.color;
  var theme = (0, _material.useTheme)();
  var avatar = function avatar(content, src, color) {
    return /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
      alt: name,
      src: src,
      sx: function sx(theme) {
        return {
          bgcolor: color,
          width: theme.spacing(size),
          height: theme.spacing(size)
        };
      }
    }, content);
  };
  if (logo) {
    return avatar(undefined, logo);
  }
  return avatar(name.charAt(0).toUpperCase(), undefined, color !== null && color !== void 0 ? color : theme.palette.primary.main);
}